import { ReactElement } from 'react'

import FindByCodigoOcOuLoteSolicitadoIdImpl from 'shared/modules/ordemCarregamento/domain/usecases/FindByCodigoOcOuLoteSolicitadoIdImpl'
import OrdemCarregamentoRepository from 'shared/modules/ordemCarregamento/infra/repositories/OrdemCarregamentoRepository'

import CancelTripImpl from '../../domain/usecases/CancelTripImpl'
import SendSmsImpl from '../../domain/usecases/SendSmsImpl'
import EndTripImpl from '../../domain/usecases/EndTripImpl'
import FindAllImpl from '../../domain/usecases/FindAllImpl'
import LoteSolicitadoRepository from '../../infra/repositories/LoteSolicitadoRepository'
import ListLotesSolicitados from '../../pages/ListLotesSolicitados'
import GetDocumentosImpl from 'modules/lotesSolicitados/domain/usecases/GetDocumentosImpl'
import GetAllDocumentosPdfImpl from 'modules/lotesSolicitados/domain/usecases/GetAllDocumentosPdfImpl'
import GetDocumentoPdfImpl from 'modules/lotesSolicitados/domain/usecases/GetDocumentoPdfImpl'
import GetDocumentoPedagioPdfImpl from 'modules/lotesSolicitados/domain/usecases/GetDocumentoPedagioPdfImpl'

export const ListLotesSolicitadosFactory = (): ReactElement => {
  const loteSolicitadoRepository = new LoteSolicitadoRepository()
  const findAllImpl = new FindAllImpl(loteSolicitadoRepository)
  const endTripImpl = new EndTripImpl(loteSolicitadoRepository)
  const cancelTripImpl = new CancelTripImpl(loteSolicitadoRepository)
  const sendSmsImpl = new SendSmsImpl(loteSolicitadoRepository)
  const ordemCarregamentoRepository = new OrdemCarregamentoRepository()
  const findByCodigoOcOuLoteSolicitadoIdImpl =
    new FindByCodigoOcOuLoteSolicitadoIdImpl(ordemCarregamentoRepository)
  const getDocumentosImpl = new GetDocumentosImpl(loteSolicitadoRepository)
  const getAllDocumentosPdfImpl = new GetAllDocumentosPdfImpl(
    loteSolicitadoRepository,
  )

  const getDocumentoPdfImpl = new GetDocumentoPdfImpl(loteSolicitadoRepository)
  const getDocumentoPedagioPdfImpl = new GetDocumentoPedagioPdfImpl(
    loteSolicitadoRepository,
  )

  return (
    <>
      <ListLotesSolicitados
        endTrip={endTripImpl}
        cancelTrip={cancelTripImpl}
        sendSms={sendSmsImpl}
        findAll={findAllImpl}
        findByCodigoOcOuLoteSolicitadoId={findByCodigoOcOuLoteSolicitadoIdImpl}
        getDocumentos={getDocumentosImpl}
        getAllDocumentosPdf={getAllDocumentosPdfImpl}
        getDocumentoPdf={getDocumentoPdfImpl}
        getDocumentoPedagioPdf={getDocumentoPedagioPdfImpl}
      />
    </>
  )
}
